import React from 'react';
import designTokens from '@/design-tokens';

interface ProgressBarProps {
  percent: number;
  height?: number;
  fillColor?: string;
  trackColor?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  percent,
  height = 8,
  fillColor = designTokens['surface/brand/primary'] || '#2bb673',
  trackColor = designTokens['surface/brand/secondary'] || '#d0f0e0',
  style,
  className,
}) => {
  const radius = height / 2;
  const clamped = Math.max(0, Math.min(100, percent));

  return (
    <div
      className={className}
      style={{
        height: `${height}px`,
        borderRadius: `${radius}px`,
        backgroundColor: trackColor,
        overflow: 'hidden',
        ...style,
      }}
    >
      <div
        style={{
          height: '100%',
          width: `${clamped}%`,
          backgroundColor: fillColor,
          borderRadius: `${radius}px`,
          transition: 'width 0.3s ease',
        }}
      />
    </div>
  );
};
